import { Injectable } from '@angular/core';
import { ProviderName } from '../../account/models/login-response.model';
import { ApiService } from '../../shared/services/core/api.service';
import { firstValueFrom } from 'rxjs';
import { LoyaltyCategoryType } from '../../shared/models/loyalty-category-types.model';
import { config } from '../../shared/config';
import { ScreenType } from './social-screen-type.enum';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class SocialService {
  constructor(private apiService: ApiService) {}

  /**
   * @param id Id of the item
   * @param typeId Auction | Lotto | Marketplace | Scorecard | Badge
   * @param returnUrl Return url to go to detail item when a customer clicks the link in social media
   * @param providerName The provider id of the social media platform
   * @returns A string of the url
   */

  share(id: number, typeId: any, returnUrl: string, providerName: ProviderName) {
    let params = new HttpParams();
    if (id) params = params.append('id', id);
    params = params.append('typeId', typeId);
    params = params.append('returnUrl', returnUrl);
    params = params.append('provider', providerName);

    return this.apiService.post<any>(`social/v2/share`, {}, params);
  }

  shareLoyalty(
    idItem: number,
    urlPage: string,
    LoyaltyCategoryType: LoyaltyCategoryType,
    ProviderName: ProviderName,
    ProviderLink: string = '',
    windowSize: ScreenType
  ) {
    let returnUrl = '';
    if (idItem) {
      returnUrl = `${config.portalUrl}/${urlPage}/${idItem}`;
    } else {
      returnUrl = `${config.portalUrl}/${urlPage}`;
    }

    firstValueFrom(this.share(idItem, LoyaltyCategoryType, returnUrl, ProviderName)).then(
      (res) => this.handleShare(res?.Url, ProviderName, ProviderLink, windowSize),
      (error) => error.status == 200 && this.handleShare(error?.error?.text)
    );
  }

  handleShare(
    url: string,
    providerName: ProviderName = ProviderName.Dummy,
    providerLink: ProviderName | string = '',
    windowSize: ScreenType = ScreenType.Mobile
  ) {
    if (windowSize == ScreenType.Desktop) {
      if (providerName == ProviderName.Dummy) {
        navigator.clipboard.writeText(url);
      } else {
        window.open(providerLink + url, '_blank');
      }
    } else if (windowSize == ScreenType.Mobile) {
      let dataShared = { url: url };
      navigator.share(dataShared);
    }
  }
}
